module.exports = {
          srcSet: __webpack_public_path__ + "public/acaf77ab35e797c0c383b6c3b2897ad1-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/acaf77ab35e797c0c383b6c3b2897ad1-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/acaf77ab35e797c0c383b6c3b2897ad1-80.png",
          toString:function(){return __webpack_public_path__ + "public/acaf77ab35e797c0c383b6c3b2897ad1-80.png"},
          
          width: 80,
          height: 80
        }